import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ModalWindow } from 'view/components/panels'
import { DealTicketContent } from './DealTicketContent'
import { EmptyTicket, TicketContainer } from 'view/shared/ticket'
import { createDealDetailSelector, createDealInterestPeriodDetailSelector } from 'selectors/dealSelectors'
import { DealDetail } from 'api'
import { getDealTitle, getDealStatusColor } from '../utils'
import { Locale, Translation } from 'locale'
import { isAdminGatewayUserSelector } from 'selectors/userSelectors'

interface DealTicketBrowserProps {
  dealId: string
  dealDetail?: DealDetail
  dealInterestPeriodDetail?: DealDetail
  isAdmin: boolean
  onClose?: () => unknown
  dealVersion?: number
}

const dealIdSelector = (_state: {}, ownProps: DealTicketBrowserProps) => ownProps.dealId
const dealVersionSelector = (_state: {}, ownProps: DealTicketBrowserProps) => ownProps.dealVersion || null

const mapStateToProps = createStructuredSelector({
  dealDetail: createDealDetailSelector(dealIdSelector),
  dealInterestPeriodDetail: createDealInterestPeriodDetailSelector(dealIdSelector, dealVersionSelector),
  isAdmin: isAdminGatewayUserSelector
})

export class DealTicketBrowserComponent extends React.Component<DealTicketBrowserProps> {
  render() {
    const { dealDetail, dealInterestPeriodDetail, isAdmin, onClose } = this.props

    const deal = dealInterestPeriodDetail ?? dealDetail
    const statusColor = deal ? getDealStatusColor(deal, isAdmin) : 'white'
    const title = deal ? getDealTitle(deal) : ''

    return (
      <ModalWindow title={title}>
        <TicketContainer statusColor={statusColor} fixedSize={true}>
          {deal ? (
            <DealTicketContent dealDetail={deal} showCloseButton={true} onClose={onClose} />
          ) : (
            <EmptyTicket>{Locale.translate(Translation.SC_DEAL_NOT_EXIST)}</EmptyTicket>
          )}
        </TicketContainer>
      </ModalWindow>
    )
  }
}

export default connect(mapStateToProps)(DealTicketBrowserComponent)
